import { call, put, select } from 'redux-saga/effects';
import {
  editTaxRateTemplateNameFailure,
  editTaxRateTemplateNameSuccess,
  getTaxRateTemplatesSuccess,
} from '../actions';
import { editTaxRateTemplateName } from '../api';
import { EditTaxRateTemplateNameRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { TaxRateTemplate } from '../models';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* editTaxRateTemplateNameSaga(
  action: EditTaxRateTemplateNameRequestAction
) {
  try {
    let err: ApiError | null;
    const { templateId, name } = action.payload;
    const response: ApiResponse = yield call(
      editTaxRateTemplateName,
      templateId,
      name
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(editTaxRateTemplateNameSuccess());

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.tax-rate-template-name-updated-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));

    // Update the templates list by updating the template name
    const currentTemplates: TaxRateTemplate[] = yield select(
      (state) => state.taxRates.taxRateTemplates
    );
    if (currentTemplates) {
      const updatedTemplates = currentTemplates.map((template) =>
        template.id === templateId ? { ...template, name } : template
      );
      yield put(getTaxRateTemplatesSuccess(updatedTemplates));
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(editTaxRateTemplateNameFailure());
  }
}

